import Vue from "vue";
import * as VueGoogleMaps from "vue2-google-maps";

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyCO_CBbkNdR-kfv1jB0LRIkf5sTIbgk77s",
    libraries: "places",
    region: "BR",
    language: "pt"
  }
});
